<template>
    <div id="ChannelForwardSetting">
        <div class="departman-card">
            <div class="mode-card">
                <div class="title">
                    {{ $t("message.departmentForwardEnable") }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        :checked="!!cloneChannel.forward.department"
                        @click="toggleDepartmentForwardingRule"
                    />
                </div>
                <div class="subtitle">{{ $t("message.departmentForwardDesc") }}</div>
                <div v-if="cloneChannel.forward.department">
                    <a-select
                        v-model="formattedDepartment"
                        :defaultValue="'null'"
                        :notFoundContent="$t('search.integration.forwardLiveAgents')"
                        style="width: 100%; margin-top: 10px"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                        show-search
                        :filter-option="filterDepartmentOption"
                        @change="handleSelectChange"
                    >
                        <a-select-option key="null" value="null">
                            {{ $t("search.integration.forwardLiveAgents") }}
                        </a-select-option>
                        <a-select-option
                            v-for="department in departments"
                            :key="department._id"
                            :value="department._id"
                        >
                            {{ getDepartmentTitle(department) }}
                        </a-select-option>
                    </a-select>
                    <a-alert
                        v-if="!isSelectedDepartmentValid"
                        description="Bu kanal yönlendirdiğiniz departmant geçerli bir departman değildir. Kanalınızı göremeyen bir departmana yönlendirme yapılıyor. Kanalın gizlilik ayarlarını kontrol ediniz."
                        message="Hatalı Departman Yönlendirme Seçimi"
                        showIcon
                        type="error"
                        class="mt-1"
                    />
                </div>
            </div>
        </div>
        <div class="mode-card-content">
            <div class="mode-card" style="max-height: 150px">
                <div class="title">
                    {{ $t("message.liveFabListDescription") }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="liveMode"
                        @change="handleLiveSupportModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t("message.AssignMessagesToAgents") }}</div>
            </div>
            <div class="mode-card" style="max-height: 150px">
                <div class="title">
                    {{ $t("chatbotv2.chatbot") }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="chatbotMode"
                        @change="handleChatbotModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t("message.firstChatbotAndAssign") }}</div>
                <div v-if="chatbotMode">
                    <a-select
                        v-model="formattedStory"
                        :notFoundContent="$t('search.integration.forwardLiveAgents')"
                        style="width: 100%"
                        :defaultValue="'null'"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                        show-search
                        :filter-option="filterStoryOption"
                        @change="handleSelectChange"
                    >
                        <a-select-option key="null" value="null">
                            {{ $t("search.integration.forwardLiveAgents") }}
                        </a-select-option>
                        <a-select-option v-for="story in stories" :key="story._id" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="mode-card">
                <div class="title">
                    {{ $t("report.hybrid") }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="hybridChatMode"
                        @change="handleHybridModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t("message.hybridAssign") }}</div>
                <div v-if="cloneChannel.forward.mode === 'hybrid'" style="margin-top: 5px">
                    <div>
                        <b style="font-size: 11px">({{ $t("message.checkDepartmentToAgent") }})</b>
                        <a-select
                            v-model="formattedHybridDepartment"
                            :notFoundContent="$t('search.integration.forwardLiveAgents')"
                            style="width: 100%"
                            :defaultValue="'null'"
                            show-search
                            :filter-option="filterDepartmentOption"
                        >
                            <a-select-option key="null" :selected="true" value="null">
                                {{ $t("search.integration.allDepartments") }}
                            </a-select-option>
                            <a-select-option
                                v-for="department in departments"
                                :key="department._id"
                                :value="department._id"
                            >
                                {{ getDepartmentTitle(department) }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div>
                        <b style="font-size: 11px">({{ $t("message.ifAllOfflineStory") }})</b>
                        <a-select
                            v-model="formattedStory"
                            :notFoundContent="$t('search.integration.forwardLiveAgents')"
                            style="width: 100%"
                            :defaultValue="'null'"
                            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                            :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                            show-search
                            :filter-option="filterStoryOption"
                            @change="handleSelectChange"
                        >
                            <a-select-option key="null" value="null">
                                {{ $t("search.integration.forwardLiveAgents") }}
                            </a-select-option>
                            <a-select-option v-for="story in stories" :key="story._id" :value="story._id">
                                {{ story.title }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="group-chatbot-card" v-if="groupChatbotView">
            <div class="mode-card">
                <div class="title">
                    Chatbot Grup Mesajlarına Cevap Versin
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        :checked="!!cloneChannel.forward.chatbotRespondToGroupChats"
                        @click="toggleChatbotRespondToGroupChats"
                    />
                </div>
                <div class="subtitle">
                    Chatbot'un grup mesajlarına cevap vermesini istiyorsanız bu seçeneği aktif hale getirin.
                </div>
            </div>
        </div>
        <div class="auto-assign-card" v-if="isChatChannel">
            <div class="mode-card">
                <div class="title">
                    Otomatik Atamayı Devre Dışı Bırak
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        :checked="!!cloneChannel.autoAssignDisabled"
                        @click="toggleAutoAssignDisabled"
                    />
                </div>
                <div class="subtitle">
                    Bu kanal için otomatik atama sistemini devre dışı bırakır. Gelen mesajlar kuyrukta bekler ancak otomatik olarak temsilcilere atanmaz fakat sahipli kişilere otomatik olarak atanır.
                    Bu ayarda yapılan değişiklikler otomatik atama sistemine 2 dakika içinde yansır.
                </div>
            </div>
        </div>
        <ZohoForwardSettings
            :channel="cloneChannel"
            @input="(c) => (cloneChannel = c)"
            v-if="enabledZohoTransfer && zohoChannelExists"
        />
    </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import ZohoForwardSettings from "./ZohoForwardSettings.vue";

export default {
    name: "ChannelForwardSetting",
    props: {
        channel: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        isDepartmentForwarding: {
            type: Boolean,
            default: false,
        },
        isChatbotSwitch: {
            type: Boolean,
            default: false,
        },
        groupChatbotView: {
            type: Boolean,
            default: false,
        },
        enabledZohoTransfer: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            liveMode: this.channel.forward.mode === "live",
            chatbotMode: this.channel.forward.mode === "chatbot",
            hybridChatMode: this.channel.forward.mode === "hybrid",
            hybridModeVisibility: false,
            cloneChannel: _.cloneDeep(this.channel),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            zohoChannelExists: (state) => !!state.channel.channels.find((x) => x.type === "zoho"),
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
        hybridDepartment: {
            get() {
                return this.cloneChannel.forward.mode === "hybrid" && this.cloneChannel.forward.hybrid
                    ? this.cloneChannel.forward.hybrid.department
                    : undefined;
            },
            set(value) {
                if (this.cloneChannel.forward.mode === "hybrid") {
                    if (!this.cloneChannel.forward.hybrid) {
                        this.$set(this.cloneChannel.forward, 'hybrid', {});
                    }
                    this.cloneChannel.forward.hybrid.department = value;
                }
            },
        },
        visibleDepartments() {
            if (this.cloneChannel.visibility && this.cloneChannel.visibility.departments) {
                return this.departments.filter((department) => {
                    return (
                        this.cloneChannel.visibility.departments.length === 0 ||
                        this.cloneChannel.visibility.departments.includes(department._id)
                    );
                });
            }
            return this.departments;
        },
        isSelectedDepartmentValid() {
            return this.visibleDepartments.some(
                (department) => department._id === this.cloneChannel.forward.department
            );
        },
        isChatChannel() {
            // Chat kanalları: webchat, whatsapp'lar, telegram, linkedin, instagram, messenger
            const chatChannelTypes = [
                'webchat',
                'whatsapp-business-api',
                'whatsapp-qr',
                'whatsapp-v2',
                'whatsapp-unipile',
                'telegram',
                'telegram-unipile',
                'linkedin-unipile',
                'instagram',
                'messenger'
            ];
            return chatChannelTypes.includes(this.cloneChannel.type);
        },
        // Formatlı departman değeri (null -> "null")
        formattedDepartment: {
            get() {
                const value = this.cloneChannel.forward.department;
                return value === null || value === undefined ? "null" : value;
            },
            set(value) {
                this.cloneChannel.forward.department = value === "null" ? null : value;
            }
        },
        // Formatlı story değeri (null/undefined -> "null")
        formattedStory: {
            get() {
                const value = this.cloneChannel.forward.story;
                return value === null || value === undefined ? "null" : value;
            },
            set(value) {
                this.cloneChannel.forward.story = value === "null" ? null : value;
            }
        },
        // Formatlı hybrid department değeri (null -> "null")
        formattedHybridDepartment: {
            get() {
                const value = _.get(this.cloneChannel, 'forward.hybrid.department');
                return value === null || value === undefined ? "null" : value;
            },
            set(value) {
                if (!this.cloneChannel.forward.hybrid) {
                    this.$set(this.cloneChannel.forward, 'hybrid', {});
                }
                this.cloneChannel.forward.hybrid.department = value === "null" ? null : value;
            }
        },
    },
    methods: {
        filterDepartmentOption(input, option) {
            const department = this.departments.find(d => d._id === option.componentOptions.propsData.value);
            if (!department) return true;
            const departmentTitle = this.getDepartmentTitle(department).toLowerCase();
            return departmentTitle.includes(input.toLowerCase());
        },
        filterStoryOption(input, option) {
            const text = option.componentOptions.children[0].text.toLowerCase();
            return text.includes(input.toLowerCase());
        },
        toggleDepartmentForwardingRule() {
            if (!!this.cloneChannel.forward.department) {
                this.cloneChannel.forward.department = null;
            } else {
                if (this.visibleDepartments.length > 0) {
                    this.cloneChannel.forward.department = this.visibleDepartments[0]._id;
                } else {
                    this.$message.error("Bu kanal için yönlendireceğiniz departman bulunamadı.");
                }
            }
            this.cloneChannel = _.cloneDeep(this.cloneChannel);
        },
        toggleChatbotRespondToGroupChats() {
            this.cloneChannel.forward.chatbotRespondToGroupChats =
                !this.cloneChannel.forward.chatbotRespondToGroupChats;
            this.cloneChannel = _.cloneDeep(this.cloneChannel);
        },
        toggleAutoAssignDisabled() {
            // Geriye dönük uyumluluk için default false
            this.cloneChannel.autoAssignDisabled = !this.cloneChannel.autoAssignDisabled;
            this.cloneChannel = _.cloneDeep(this.cloneChannel);
        },
        checkHaveChatbotStory(id) {
            return this.stories.find((story) => story._id === id);
        },
        handleLiveSupportModeChange(value) {
            this.liveMode = value;
            if (value) {
                this.chatbotMode = false;
                this.hybridChatMode = false;
                this.cloneChannel.forward.story = null;
            }
            this.cloneChannel.forward.mode = value ? "live" : "";
        },
        handleChatbotModeChange(value) {
            this.chatbotMode = value;
            if (value) {
                this.liveMode = false;
                this.hybridChatMode = false;
            }
            this.cloneChannel.forward.mode = value ? "chatbot" : "";
        },
        handleHybridModeChange(value) {
            this.hybridModeVisibility = true;
            this.hybridChatMode = value;
            if (value) {
                this.liveMode = false;
                this.chatbotMode = false;
            }
            this.cloneChannel.forward.mode = value ? "hybrid" : "";
        },
        handleDepartmentChange(id) {
            return this.departments.find((story) => story._id === id);
        },
        isVisibleDepartment(id) {
            return this.visibleDepartments.some((department) => department._id === id);
        },
        getDepartmentTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            const isVisible = this.isVisibleDepartment(department._id);
            return isVisible
                ? _.get(department, key)
                : `${_.get(department, key)} (Bu departman gizlilik ayarları nedeniyle uyumsuzdur)`;
        },
        handleSelectChange(value) {
            if (value === null) {
                value = undefined;
            }
        },
    },
    components: {
        ZohoForwardSettings,
    },
    watch: {
        cloneChannel: {
            handler() {
                const isEquals = _.isEqual(this.cloneChannel, this.channel);
                if (!isEquals) {
                    this.$emit("input", this.cloneChannel);
                }
            },
            deep: true,
        },
        channel: {
            handler() {
                this.cloneChannel = _.cloneDeep(this.channel);
            },
            deep: true,
        },
        "cloneChannel.forward.department": {
            handler(value) {
                const isVisible = this.isVisibleDepartment(value);
                if (!isVisible) {
                    this.$message.error(
                        "Bu kanalı yönlendirdiğiniz departmant geçerli bir departman değildir. Kanalınızı göremeyen bir departmana yönlendirme yapılıyor. Kanalın gizlilik ayarlarını kontrol ediniz."
                    );
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
#ChannelForwardSetting {
    margin-top: 20px;

    .departman-card {
        margin-bottom: 20px;
    }

    .group-chatbot-card {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .auto-assign-card {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .mode-card-content {
        display: flex;
        gap: 20px;
        justify-content: space-between;
    }

    .mode-card {
        width: 100%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .alert {
        color: red;
        font-size: 14px;
        margin-top: 5px;
    }
}

::v-deep .ant-select-dropdown {
    position: relative !important;
}
</style>
